import { normalizeError } from 'core/common/errors';
import { AppThunk } from 'core/common/store';
import { EmailFlowAttributes } from 'core/flow/entities';
import { getDefaultOffers } from 'core/offers/store/selectors';
import { getOfferReportTypes } from 'core/offers/utils';
import { OrderData } from 'core/payments/entities';
import { getUserInformation } from '../userProfile/selectors';

export const addReading =
  (emailFlowAttributes: EmailFlowAttributes['emailFlowAttributes']): AppThunk =>
  async (_, getState, context) => {
    const { userReadingService, loggingService } = context;

    const userInformation = getUserInformation(getState());
    const defaultOffers = getDefaultOffers(getState());
    const defaultOffer = defaultOffers[0];

    if (!defaultOffer) {
      loggingService.error('Default offer is not found');
      return;
    }

    if (!emailFlowAttributes || !emailFlowAttributes.reports) {
      loggingService.error('Email flow attributes or reports are not found');
      return;
    }

    const reportTypes = getOfferReportTypes(emailFlowAttributes.reports, defaultOffer.offerId);

    if (!reportTypes.length) {
      loggingService.error('Report types for default offer is not found');
      return;
    }

    const nebulaId = userInformation.nebulaId;

    const orderData: Partial<OrderData> = {
      subjects: [
        {
          assigned_to: 'partner_1',
          birth_place: {
            place: userInformation.location || 'Greenwich, Greater London, United Kingdom',
            longitude: userInformation.place[0] || 0.05,
            latitude: userInformation.place[1] || 51.45,
          },
          gender: userInformation.gender,
          birth_date: userInformation.date || '1990-01-01',
          birth_time: userInformation.time,
        },
        {
          assigned_to: 'partner_2',
          birth_place: {
            place: userInformation.partnerLocation || 'Greenwich, Greater London, United Kingdom',
            latitude: userInformation.partnerPlace[0] || 0.05,
            longitude: userInformation.partnerPlace[1] || 51.45,
          },
          gender: userInformation.partnerGender || 'male',
          birth_date: userInformation.partnerDate || '1990-01-01',
          birth_time: userInformation.partnerTime,
        },
      ],
    };

    const payloadData = {
      user_id: Number(nebulaId),
      readings: reportTypes.map((type) => ({ type })),
      extra_data: {
        orderData,
      },
    };

    try {
      await userReadingService.addReading(payloadData);
    } catch (err) {
      const error = normalizeError(err);
      loggingService.error(error);
    }
  };
